import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Welcome from '../../components/welcome/welcome';

const HomePage = ({ isLoggedIn, isAdmin, history }) => {
  if (!isLoggedIn) {
    return <Welcome />;
  }

  const path = isAdmin ? '/orders-list' : '/create-order';
  history.replace(path);

  return null;
};

HomePage.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
};

const mapState = state => ({
  isLoggedIn: !!state.auth.token,
  isAdmin: state.auth.roles.indexOf('Admin') !== -1,
});

export default withRouter(
  connect(mapState, null)(HomePage),
);
